<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Miktarı</label>
            <v-currency-input input-class="text-right currency-font-size" :value="value.TotalAmount" v-on:updateValue="v => value.TotalAmount = v"></v-currency-input>
        </div>
        <div class="col-12" v-if="!value.fromHome">
            <b-form-checkbox v-model="value.CanInstallment">Taksit Yapılabilir</b-form-checkbox>
        </div>
        <div class="col-12" v-if="!value.fromHome">
            <b-form-checkbox v-model="value.SendCustomer">Müşteriye Gönderilsin</b-form-checkbox>
        </div>
        <div class="col-12 mt-1">
            <label>Açıklama</label>
            <b-form-textarea  v-model="value.Description"></b-form-textarea>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormCheckbox,BFormTextarea } from 'bootstrap-vue'
export default {
    props:{
        value:Object
    },
    components: { 
        VCurrencyInput,
        BFormCheckbox,
        BFormTextarea
    },
}
</script>

<style>

</style>